import OrderList from '../../../components/Purchasing/Order/OrderList'
import ReadyToOrderList from '../../../components/Purchasing/Order/ReadyToOrderList'
import OrderModal from '../../../components/Purchasing/Order/OrderModal'
import PageTitle from '../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Row, Tabs } from 'antd'
import React, { Fragment } from 'react'

const { Content } = Layout
const { TabPane } = Tabs

function ReadyToOrder(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="/#/purchasing/Order/">Purchasing</Breadcrumb.Item>
              <Breadcrumb.Item>Order</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Order'}
              subtitle={'View and create purchasing orders'}
              color={'#427035'}
              iconType={'dollar'}
            />
          </Row>
        </Card>

        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <OrderModal {...props} />
            <Tabs defaultActiveKey={'#ReadyToOrder'}>
              <TabPane tab="Ready To Order" key="#ReadyToOrder">
                <ReadyToOrderList {...props} />
              </TabPane>
              <TabPane tab="Orders" key="#orders">
                <OrderList {...props} />
              </TabPane>
            </Tabs>
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

ReadyToOrder.propTypes = {}
ReadyToOrder.defaultProps = {}

export default ReadyToOrder
